<template>
  <div class="mt-5">
    <h4>Input your payment email</h4>
    <input type="text" class="mt-4" @keyup="updateValue($event.target.value)">
  </div>
</template>
<script>

export default {
  props: {
    email: String
  },
  methods: {
    updateValue(value) {
      this.$store.dispatch('updateEmail', value)
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  width: 300px;
  border: 3px solid #C9D6FF;
  border-radius: 4px;
  font-size: 1.5rem;
}
</style>

